const licensingPartnerIgnoreFilterKeys = ['order_by', 'sort_by', 'page_number', 'page_size'];

export default licensingPartnerIgnoreFilterKeys;
